import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  groupId = '';
  groupNumber = '';
  billingEntityId = '';
  policyNumber = '';
  policyName = '';
  policyNumbers: string[] = [];
  coverageCodes: string[] = [];

  setgroupId(groupId: string): void {
    this.groupId = groupId;
  }

  setgroupNumber(groupNumber: string): void {
    this.groupNumber = groupNumber;
  }

  setpolicyId(policyId: string): void {
    this.policyNumber = policyId;
  }

  setbillingEntityId(billingEntityId: string): void {
    this.billingEntityId = billingEntityId;
  }

  setpolicyIds(policyIds: string[]): void {
    this.policyNumbers = [...new Set(policyIds)];
  }

  setpolicyName(policyName: string): void {
    this.policyName = policyName;
  }

  setCoverageCodes(codes: string[]): void {
    this.coverageCodes = [...new Set(codes)];
  }
}
